import { createFileRoute } from "@tanstack/react-router";
import { MemberList } from "@/features/members/MemberList";

export const Route = createFileRoute("/_layout/members")({
  component: MemberList,
});
